/**
 * Text Input Field UI component
 * @Author: Junaid Atari junaid.attari@invozone.dev
 * @Date: 2025-02-17 17:24:24
 */

import React from 'react';

// ui
import {TextField, TextFieldProps} from '@shopify/polaris';

// types
import type {FieldInfo} from '~/types/field.types';
import type {FormikProps, FormikValues} from 'formik';

export interface TextInputFieldProps {
  /** The field info schema */
  fieldInfo: FieldInfo;

  /** The formik instance */
  formik: FormikProps<any>,

  /** Polaris text-field component properties  */
  textFieldProps?: Partial<TextFieldProps>;

  /**
   * Callback fired when the value is changed
   * @param value - The updated value
   * @param fieldInfo t- Te field info
   * @param formik - The formik instance
   */
  afterChange?(
    value: unknown,
    fieldInfo: FieldInfo,
    formik: FormikProps<any>,
  ): void;
}

const TextInputField: React.FC<TextInputFieldProps> = (props) => {
  const isTouched = props.formik.touched[props.fieldInfo.key as keyof FormikValues];

  return (
    <TextField
      type={props.fieldInfo.type === 'numeric' ? 'number' : 'text'}
      {...(props.textFieldProps ?? {})}
      label={props.fieldInfo.label}
      placeholder={props.fieldInfo.placeholder}
      onChange={value => {
        props.formik.setFieldValue(props.fieldInfo.key, value, true);
        props.afterChange?.(value, props.fieldInfo, props.formik);
      }}
      autoComplete="off"
      value={props.formik.values[props.fieldInfo.key]}
      requiredIndicator={props.fieldInfo.required}
      error={isTouched ? String(props.formik.errors?.[props.fieldInfo.key] ?? '') : false}
      helpText={props.fieldInfo.helpText && (
        <span>{props.fieldInfo.helpText}</span>
      )}
    />
  );
};

export default TextInputField;
